/** Registers the ParallaxLayer parser. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseParallaxLayer } from './parser';
const parallaxLayerRegistration = {
    typeName: 'ParallaxLayer',
    parser: parseParallaxLayer,
};
nodeRegistry.register(parallaxLayerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map